module.exports = wphtmlmailwoocommerce;